// reloadInventoryEpic.ts
import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  RELOAD_INVENTORY_REQUEST,
  RELOAD_INVENTORY_SUCCESS,
  EPIC_ERROR,
} from 'Constants/redux';
import { ROOT_URL } from 'Api';
import service from 'Api/service';
import { apiConnections } from 'Constants/displayConstants';

const reloadInventoryEpic = (action$) =>
  action$.pipe(
    ofType(RELOAD_INVENTORY_REQUEST),
    debounceTime(500),
    switchMap((action) => {
      const link = action.options.for_connect
        ? `${ROOT_URL}/connect/inventories/paginated`
        : `${ROOT_URL}/${apiConnections[action.inventoryType]}/paginated`;

      return from(service.post(link, action.options)).pipe(
        map((response) => ({
          type: RELOAD_INVENTORY_SUCCESS,
          response,
          inventoryType: action.inventoryType,
        })),
        catchError((err) => {
          console.error('reloadInventoryEpic error', err);
          return of({ type: EPIC_ERROR });
        })
      );
    })
  );

export default reloadInventoryEpic;
